import { APP_INITIALIZER, Provider } from '@angular/core';
import { SecureTokenService } from './secure-token.service';

/**
 * APP_INITIALIZER that runs before Angular bootstraps the router or fires any
 * HTTP request. On native it copies the keystore-backed JWT into the
 * window.localStorage mirror so the synchronous token reads in
 * ApiKeyInterceptor / AuthenticationService see a logged-in session on cold
 * start. No-op on web.
 */
export function rehydrateSecureToken(secureToken: SecureTokenService): () => Promise<void> {
  return () => secureToken.rehydrate();
}

export const NATIVE_INIT_PROVIDER: Provider = {
  provide: APP_INITIALIZER,
  useFactory: rehydrateSecureToken,
  deps: [SecureTokenService],
  multi: true,
};
